angular.module('memberPortal').controller('ShowEventCtrl', ["$scope", "$state", "$stateParams", "$http", "$window", "$modal", "DataService", "$filter", "MessageService", "event", function($scope, $state, $stateParams, $http, $window, $modal, DataService, $filter, MessageService, event) {
  var clearMessages, domain, getBookAllLimits, isPastEvent, parseTime, reloadEvent;
  $scope.data = DataService;
  $scope.hash = $stateParams.m;
  $scope.origin = $stateParams.origin;
  domain = $scope.data.domain;
  $scope.event = event;
  getBookAllLimits = function() {
    var url;
    url = `/websites/${DataService.domain}/members/events/${$scope.event.id}/book_all_limits`;
    return $http.get(url).then(function(response) {
      return $scope.bookAllLimits = response.data;
    });
  };
  getBookAllLimits();
  reloadEvent = function() {
    var url;
    getBookAllLimits();
    $scope.isLoading = true;
    url = `/websites/${DataService.domain}/members/events/${$scope.event.id}`;
    return $http.get(url).then(function(response) {
      $scope.isLoading = false;
      return $scope.event = response.data;
    }, function() {
      return $scope.isLoading = false;
    });
  };
  clearMessages = function() {
    return $scope.error = '';
  };
  $scope.isBooked = function() {
    var ref;
    return (ref = $scope.event.member_portal_booking_status) === 'Booked' || ref === 'Absent' || ref === 'Attended';
  };
  parseTime = function(time, event) {
    if (event.event_tz_type === 'browser') {
      return moment.utc(time, 'YYYY/MM/DD HH:mm').local();
    } else {
      return moment(time, 'YYYY/MM/DD HH:mm');
    }
  };
  isPastEvent = function() {
    var endMoment;
    endMoment = parseTime($scope.event.end_at, $scope.event);
    return moment().isSameOrAfter(endMoment, 'minute');
  };
  $scope.isFutureEventsAvailable = function() {
    var ref;
    return ((ref = $scope.bookAllLimits) != null ? ref.event_count : void 0) > 1;
  };
  $scope.isCancelAvailable = function() {
    return $scope.isBooked() && $scope.event.cancellable && $scope.event.cancellable_by_member && !isPastEvent();
  };
  $scope.isLateCancelAvailable = function() {
    return $scope.isBooked() && !$scope.isCancelAvailable() && $scope.event.allow_late_cancellations;
  };
  $scope.lateCancellationFeeExists = function() {
    return !!parseFloat($scope.event.late_cancellation_fee);
  };
  $scope.lateCancelBooking = function() {
    var fee, message, messageParams;
    message = $scope.lateCancellationFeeExists() ? (fee = $filter('currency')($scope.event.late_cancellation_fee, $scope.data.currency), `Please note: A fee of ${fee} applies to late cancellations for this class.`) : void 0;
    if (isPastEvent()) {
      $scope.error = 'Cannot cancel a booking in the past.';
      window.scrollTo(0, 0);
      return;
    }
    messageParams = {
      title: 'Are you sure you want to cancel this booking?',
      message: message,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    };
    return MessageService.message(messageParams).then(function() {
      var bookingId, url;
      bookingId = $scope.event.member_portal_booking_id;
      url = `/websites/${domain}/members/bookings/${bookingId}/late_cancel`;
      $scope.isLoading = true;
      return $http.delete(url).then(function(data) {
        return reloadEvent();
      }, function(response) {
        $scope.isLoading = false;
        return $scope.error = response.data.error;
      });
    });
  };
  $scope.cancelBooking = function() {
    var messageParams;
    if (isPastEvent()) {
      $scope.error = 'Cannot cancel a booking in the past.';
      window.scrollTo(0, 0);
      return;
    }
    messageParams = {
      title: 'Are you sure you want to cancel this booking?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    };
    return MessageService.message(messageParams).then(function() {
      var bookingId, url;
      clearMessages();
      bookingId = $scope.event.member_portal_booking_id;
      url = `/websites/${domain}/members/bookings/${bookingId}`;
      $scope.isLoading = true;
      return $http.delete(url).then(function(data) {
        return reloadEvent();
      }, function(response) {
        $scope.isLoading = false;
        return $scope.error = response.data.error;
      });
    });
  };
  $scope.isBookingAvailable = function() {
    if (DataService.block_bookings_before_hour) {
      return parseInt(moment(new Date()).format("HH")) >= DataService.block_bookings_before_hour;
    }
  };
  $scope.displayAvailableTimeForBooking = function() {
    var blockBookingsBeforeHour;
    blockBookingsBeforeHour = `${DataService.block_bookings_before_hour}:00`;
    return moment(blockBookingsBeforeHour, "HH:mm").format("h:mm a");
  };
  $scope.bookIn = function() {
    var url;
    clearMessages();
    url = `/websites/${domain}/members/bookings`;
    $scope.isLoading = true;
    return $http.post(url, {
      booking: {
        event_id: event.id
      }
    }).then(function(data) {
      return reloadEvent();
    }, function(response) {
      $scope.isLoading = false;
      return $scope.error = response.data.error;
    });
  };
  $scope.joinWaitlist = function() {
    var params, url;
    clearMessages();
    params = {
      event_id: $scope.event.id,
      contact_id: DataService.member_details.id
    };
    url = `/websites/${domain}/members/waitlist_attendees`;
    $scope.isLoading = true;
    return $http.post(url, params).then(function(data) {
      return reloadEvent();
    }, function(response) {
      $scope.isLoading = false;
      return $scope.error = response.data.error;
    });
  };
  $scope.leaveWaitlist = function() {
    var id, url;
    if ($window.confirm("Leave waitlist for this event?")) {
      clearMessages();
      id = $scope.event.waitlist_attendee_id;
      url = `/websites/${domain}/members/waitlist_attendees/${id}`;
      $scope.isLoading = true;
      return $http.delete(url).then(function(data) {
        return reloadEvent();
      }, function(response) {
        $scope.isLoading = false;
        return $scope.error = response.data.error;
      });
    }
  };
  $scope.bookAll = function() {
    var classPackLimit, dateLimit, eventCount, eventDate, futureBookingPlural, futureBookingsCountLimit, futureBookingsDate, message, modalInstance;
    dateLimit = $scope.bookAllLimits.date_limit ? $filter('date')($scope.bookAllLimits.date_limit) : null;
    eventCount = $scope.bookAllLimits.event_count;
    classPackLimit = $scope.bookAllLimits.class_pack_limit;
    eventDate = $filter('date')($scope.event.start_date);
    futureBookingsCountLimit = $scope.bookAllLimits.future_bookings_count_limit;
    futureBookingsDate = $filter('date')($scope.bookAllLimits.future_bookings_date_limit);
    futureBookingPlural = $filter('pluralize')('bookings', futureBookingsCountLimit);
    message = (function() {
      switch (false) {
        case !(!!futureBookingsCountLimit && !!$scope.bookAllLimits.future_bookings_date_limit):
          return [`Your membership allows you to hold up to ${futureBookingsCountLimit} ${futureBookingPlural} between now and ${futureBookingsDate}.`, "Would you like to continue?"];
        case !$scope.bookAllLimits.future_bookings_date_limit:
          return ["Your membership limits how far into the future classes can be booked.", `This will book classes up to ${futureBookingsDate}, or until the membership expires.`, "Would you like to continue?"];
        case !futureBookingsCountLimit:
          return [`Your membership allows up to ${futureBookingsCountLimit} future ${futureBookingPlural} to be held at a time.`, "Would you like to continue?"];
        case !(!!$scope.bookAllLimits.date_limit && !classPackLimit):
          return [`There are ${eventCount} ${$scope.event.name} events between ${eventDate} and when your membership expires, on ${dateLimit}.`, `Book all ${eventCount} events?`];
        case !(!!classPackLimit && !$scope.bookAllLimits.date_limit):
          return [`Your membership(s) have ${classPackLimit} bookings remaining.`, `Book the next ${classPackLimit} events in this series?`];
        case !(!!classPackLimit && !!$scope.bookAllLimits.date_limit):
          return [`Your membership(s) have ${classPackLimit} bookings remaining, and continue until ${dateLimit}. This will book the next ${classPackLimit} events in this series, or up to your membership expiry date - whichever happens sooner.`, "Would you like to continue?"];
        default:
          return [`There are ${eventCount} ${$scope.event.name} events remaining in this series.`, `Book all ${eventCount} events?`];
      }
    })();
    modalInstance = $modal.open({
      template: require('templates/member_portal/events/book_all_modal.html.slim'),
      windowClass: 'message-modal',
      resolve: {
        message: function() {
          return message;
        }
      },
      controller: ["$scope", "$modalInstance", "message", function($scope, $modalInstance, message) {
        $scope.message = message;
        $scope.title = 'Book all events';
        $scope.state = 'initial';
        $scope.displayEventTime = function(event) {
          var date, dateTime, time;
          dateTime = moment(event.start_at);
          time = dateTime.format('h:mma');
          date = dateTime.format('D-MMM-YYYY');
          return `${time} on ${date}`;
        };
        $scope.getBookedEventsCount = function() {
          return $scope.bookedEvents.length;
        };
        $scope.getFirstBookedEventDate = function() {
          if (!$scope.bookedEvents.length) {
            return;
          }
          event = $scope.bookedEvents[0];
          return $scope.displayEventTime(event);
        };
        $scope.getLastBookedEventDate = function() {
          if (!$scope.bookedEvents.length) {
            return;
          }
          event = _.last($scope.bookedEvents);
          return $scope.displayEventTime(event);
        };
        $scope.submit = function() {
          var url;
          $scope.state = 'loading';
          url = `/websites/${domain}/members/bulk_bookings`;
          return $http.post(url, {
            booking: {
              event_id: event.id
            }
          }).then(function(response) {
            var ref;
            $scope.state = 'success';
            $scope.bookedEvents = (ref = response.data.bookings) != null ? ref.valid : void 0;
            return $scope.title = "You're booked in!";
          }, function(response) {
            var defaultMessage, ref;
            defaultMessage = "Sorry, we are unable to book all remaining events at this time";
            $scope.error = response.data.message || defaultMessage;
            $scope.invalidBookings = (ref = response.data.bookings) != null ? ref.invalid : void 0;
            $scope.state = 'error';
            return $scope.title = "Unable to book";
          });
        };
        return $scope.close = function() {
          return modalInstance.close();
        };
      }]
    });
    return modalInstance.result.then(function() {
      return reloadEvent();
    });
  };
  $scope.getDate = function() {
    return parseTime($scope.event.start_at, $scope.event).format('ddd, D MMMM, YYYY');
  };
  return $scope.getTime = function() {
    var end, start;
    start = parseTime($scope.event.start_at, $scope.event).format('h:mma');
    end = parseTime($scope.event.end_at, $scope.event).format('h:mma');
    return `${start} - ${end}`;
  };
}]);
